import React, { useMemo } from 'react';
import strings from 'strings';

import { DetailsTabs } from '../../../shared';

import { SendoverAttachmentsTabContent } from './SendoverAttachmentsTabContent';

const buildTabs = ({ sendoverId }) => [
  {
    id: 'Attachments',
    label: strings.sendoutsV2.drawers.tabs.attachments.title,
    view: <SendoverAttachmentsTabContent sendoverId={sendoverId} />
  },
  {
    id: 'Emails',
    label: strings.sendoutsV2.drawers.tabs.emails.title,
    view: <div>Emails Content</div>
  },
  {
    id: 'ActivityLogs',
    label: strings.sendoutsV2.drawers.tabs.activityLogs.title,
    view: <div>Activity Logs Content</div>
  }
];

export const SendoverDetailsTabs = ({ sendoverId }) => {
  const tabs = useMemo(() => buildTabs({ sendoverId }), [sendoverId]);

  return <DetailsTabs initialTab={tabs[0].id} tabs={tabs} />;
};
